import axios from 'axios';

const CACHE_TTL_MS = 4 * 60 * 60 * 1000; // 4 hours (SAS tokens last 10 years)

/** { [blobName]: { url, ts } } */
const urlCache = new Map();

/** { [blobName]: Promise<string|null> } — deduplicates concurrent fetches */
const inflight = new Map();

/**
 * Get an avatar URL for a blob name. Results are cached in-memory and
 * concurrent requests for the same blob are deduplicated to a single fetch.
 */
export const getAvatarUrl = async (blobName) => {
  if (!blobName) return null;

  const cached = urlCache.get(blobName);
  if (cached && Date.now() - cached.ts < CACHE_TTL_MS) {
    return cached.url;
  }

  if (inflight.has(blobName)) {
    return inflight.get(blobName);
  }

  const promise = axios
    .get(`/api/profile/avatar/${blobName}`)
    .then((res) => {
      const url = res.data.avatar_url || null;
      urlCache.set(blobName, { url, ts: Date.now() });
      inflight.delete(blobName);
      return url;
    })
    .catch((error) => {
      console.error('Failed to get avatar URL:', error);
      inflight.delete(blobName);
      return null;
    });

  inflight.set(blobName, promise);
  return promise;
};

/** Pre-warm the cache for a batch of blob names (e.g. from a user list). */
export const prefetchAvatars = (blobNames) => {
  if (!Array.isArray(blobNames)) return;
  for (const name of blobNames) {
    if (name && typeof name === 'string' && !/^https?:\/\//i.test(name) && !name.startsWith('/')) {
      getAvatarUrl(name);
    }
  }
};
